'use strict';

exports.__esModule = true;
exports.default = {
  SMALL: 'small',
  MEDIUM: 'medium',
  STANDARD: 'standard',
  LARGE: 'large',
  XLARGE: 'xlarge'
};
//# sourceMappingURL=MessengerSize.js.map


//////////////////
// WEBPACK FOOTER
// ./~/react-facebook/lib/constants/MessengerSize.js
// module id = 453
// module chunks = 198517197184460